import React from 'react'
import HeaderTwo from '../components/layout/HeaderTwo'
import AppFooter from '../components/layout/FooterTwo'
import { Outlet } from 'react-router-dom'

function LayoutTwo() {
  return (
    <div>
      <HeaderTwo />
      <Outlet />
      <AppFooter />
    </div>
  )
}

export default LayoutTwo
